import {
  IntrospectBreakpointStatus,
  IntrospectShellStatus,
  formatIntrospectionStatus,
} from '@todesktop/shared';

export { formatIntrospectionStatus };

export function getIntrospectionStatusIndicator(
  breakpointStatus?: IntrospectBreakpointStatus,
  shellStatus?: IntrospectShellStatus,
): string {
  if (shellStatus === 'connected') {
    return '◆';
  }

  if (breakpointStatus === 'paused') {
    return '⏸';
  }

  if (breakpointStatus === 'ready') {
    return '✓';
  }

  if (breakpointStatus === 'initializing' || shellStatus === 'initializing') {
    return '⋯';
  }

  if (breakpointStatus === 'finished') {
    return '■';
  }

  if (breakpointStatus === 'error' || shellStatus === 'error') {
    return '✗';
  }

  return '○';
}
